// extracted by mini-css-extract-plugin
module.exports = {"subsTxt":"JvxBy","logoutToast":"ZXukI","ssoLoginWrap":"DjMIQ","hide":"CKQxD","ssoLogin":"Qh_F7","spin":"jn5cz"};